import React from "react";
import { useTranslations } from "@jugl-web/utils";
import { useManageAccountsDrawer } from "@web-src/modules/client-support/pages/ClientSupportPage/components/ManageAccountsDrawer/providers/ManageAccountsDrawerContext";
import { ChannelTile } from "../ChannelTile";
import { ReactComponent as TwilioIcon } from "./assets/twilio.svg";

export const TwilioTile: React.FC<{
  isSelected: boolean;
  onSelect: () => void;
}> = (props) => {
  const { t } = useTranslations();
  const { crmConfig, openManageAccountDrawer } = useManageAccountsDrawer();

  const config = crmConfig?.twilio;

  return (
    <ChannelTile
      title={t({
        id: "cx-ai-agents-page.sms-chat",
        defaultMessage: "SMS Chat",
      })}
      isConnected={!!config?.id}
      onClick={() => openManageAccountDrawer({ name: "twilioAccount" })}
      description={
        config?.id
          ? config.phone_num
          : t({
              id: "cx-ai-agents-page.twilio-connect-description",
              defaultMessage: "Quick way for business communications",
            })
      }
      icon={<TwilioIcon />}
      status={
        config?.id
          ? {
              type: "connected",
              text: t({
                id: "common.connected",
                defaultMessage: "Connected",
              }),
            }
          : undefined
      }
      {...props}
    />
  );
};
